import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';

import { PCPCommunityDropdownComponent } from "./pcp-community-dropdown.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        SelectModule,
        PCPCommunityDropdownComponent,
    ],
    exports: [PCPCommunityDropdownComponent]
})
export class PCPCommunityDropdownModule { }
